import { useWorkerWorkBadgesMaxUi } from "@src/appV2/redesign/WorkBadges/hooks/useWorkerWorkBadgesMaxUi";
import { WorkBadgesProfilePage } from "@src/appV2/redesign/WorkBadges/Profile/Page";

import { useIndependentContractorBadgeRevamp } from "./hooks/useIndependentContractorBadgeRevamp";
import { IndependentContractorBadgePageV1 } from "./PageV1";
import { IndependentContractorBadgePageV2 } from "./PageV2";

export function IndependentContractorBadgePage() {
  const { isEnabled } = useIndependentContractorBadgeRevamp();
  const { enabled: workerWorkBadgesMaxUiEnabled } = useWorkerWorkBadgesMaxUi();

  if (workerWorkBadgesMaxUiEnabled) {
    return <WorkBadgesProfilePage />;
  }

  if (isEnabled) {
    return <IndependentContractorBadgePageV2 />;
  }

  return <IndependentContractorBadgePageV1 />;
}
